import data from "../data/cloud.json";


const awsQuiz = data.aws;


export {awsQuiz};